import { Paragraph } from '@zillow/constellation-10';

import { RentalManagerUserClaimType } from '@zg-rentals/ts-rental-manager-api-client';
import { useRentalManagerUserClaimWebApiHandler_getExclusiveProperties } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import numberUtils from '../../../../utils/numberUtils';

import { DEFAULT_ERROR_MESSAGE } from '../../../../constants/ErrorMessageConstants';

import ClaimListingCard from '../../../ClaimListingCard';

const { formatPhoneNumberInput } = numberUtils;

const DeleteClaimContact = ({ contactToDelete }: { contactToDelete: { value: string; type: string } }) => {
  const { value, type } = contactToDelete;
  const claimType = type === 'email' ? RentalManagerUserClaimType.EMAIL : RentalManagerUserClaimType.PHONE;

  const {
    data,
    isLoading: loadingListings,
    isError: hasError,
  } = useRentalManagerUserClaimWebApiHandler_getExclusiveProperties({ type: claimType, value });

  const contactType = isNaN(parseInt(value, 10)) ? 'email' : 'phone';
  const formattedContactMethod = contactType === 'email' ? value : formatPhoneNumberInput(value);
  const associatedListings = data?.listings ?? [];
  const subHeadingText =
    associatedListings.length > 0 ? 'the following listings will be removed. We will also ' : 'we will ';

  return (
    <div data-testid="DeleteClaimContact">
      <Paragraph css={{ textStyle: 'heading-sm' }} className="fs-mask">
        {`Are you sure you want to remove ${formattedContactMethod}?`}
      </Paragraph>
      <Paragraph css={{ marginBlock: '400' }}>
        {`By removing this contact method, ${subHeadingText}not be able to inform you of new listings that match the contact.`}
      </Paragraph>
      {associatedListings.map((listing) => (
        <ClaimListingCard
          key={listing?.listingAlias}
          listingData={listing}
          highlightPhone={type === 'phone'}
          highlightEmail={type === 'email'}
          loading={loadingListings}
        />
      ))}
      {hasError && <Paragraph css={{ color: 'text.feedback.critical.strong' }}>{DEFAULT_ERROR_MESSAGE}</Paragraph>}
    </div>
  );
};

export default DeleteClaimContact;
